import { type PhotoCaptureRequestStatus } from '../../../services/photoCapture';
import { TimerObserver } from '../../../libs/timerObserver';
import { timerKeys } from '../../../shared/constants';
import { getLogger } from '../../../libs/logger';

export const PhotoCaptureTimer = new TimerObserver<PhotoCaptureRequestStatus>(
  timerKeys.photoCapture,
  getLogger('photoCaptureTimer'),
);
